import { InteractiveContainer } from "@jugl-web/ui-components";
import { Radio } from "@jugl-web/ui-components/cross-platform/Radio";
import { cx } from "@jugl-web/utils";
import React from "react";

export interface ResponseModeOptionProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: React.ReactNode;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
}

export const ResponseModeOption: React.FC<ResponseModeOptionProps> = ({
  icon: Icon,
  title,
  description,
  isSelected,
  isDisabled,
  onSelect,
}) => (
  <InteractiveContainer
    onClick={onSelect}
    isDisabled={isDisabled}
    className={cx(
      "flex w-full max-w-[600px] items-center gap-2 rounded-2xl border border-solid p-4 transition-colors",
      isSelected
        ? "border-dark-100 bg-grey-100"
        : "border-dark-100 bg-white hover:bg-grey-100",
      isDisabled && "opacity-60"
    )}
  >
    <Icon className="h-[18px] w-[18px] shrink-0" />
    <div className="flex grow flex-col gap-0.5">
      <span className="font-secondary text-sm font-medium text-dark">
        {title}
      </span>
      <span className="font-secondary text-[13px] leading-[140%] text-dark-600">
        {description}
      </span>
    </div>
    <Radio
      size="lg"
      isChecked={isSelected}
      readOnly
      className="pointer-events-none shrink-0 border-[#DEDEE4] checked:border-[#2F80ED] checked:bg-[#2F80ED] checked:hover:bg-[#2F80ED] checked:focus:bg-[#2F80ED]"
    />
  </InteractiveContainer>
);
